import { FunctionComponent, KeyboardEvent, useState } from "react";

import { faXmark } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

interface TokenInputProps {
	label: string;
	values: string[];
	placeholder: string;
	onChange: (values: string[]) => void;
}

/** A simple token list: type + Enter to add, click the × to remove (PREC-3719 §6). */
export const TokenInput: FunctionComponent<TokenInputProps> = ({
	label,
	values,
	placeholder,
	onChange,
}) => {
	const [draft, setDraft] = useState("");

	const add = () => {
		const trimmed = draft.trim();

		if (trimmed && !values.includes(trimmed)) {
			onChange([...values, trimmed]);
		}

		setDraft("");
	};

	const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			event.preventDefault();
			add();
		}
	};

	return (
		<div className="flex flex-col gap-1.5">
			<span className="text-xs font-semibold text-text">{label}</span>
			{values.length > 0 && (
				<div className="flex flex-wrap gap-1.5">
					{values.map((value) => (
						<span
							key={value}
							className="flex items-center gap-1 rounded-md bg-blue-action-200 px-2 py-0.5 text-xs text-brand-light"
						>
							{value}
							<button
								className="cursor-pointer hover:text-status-error"
								type="button"
								onClick={() => onChange(values.filter((item) => item !== value))}
							>
								<Icon className="h-2.5 w-2.5" icon={faXmark} />
							</button>
						</span>
					))}
				</div>
			)}
			<input
				className="input-styles w-full rounded-lg px-3 py-1.5 text-sm"
				placeholder={placeholder}
				value={draft}
				onBlur={add}
				onChange={(event) => setDraft(event.target.value)}
				onKeyDown={onKeyDown}
			/>
		</div>
	);
};
